import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import Modal from '../../components/ModalB';

import {
    renderField,
    renderDayPickerB,
    SelectField,
    AsyncSelectField,
    renderCurrencyFloat,
    renderFilePickerB,
    renderNumber,
} from "../../Utils/renderField/renderField";

function LiquidacionBonosForm(props) {
    const {
        crear,
        bloqueo,
        editar,
        listarProveedores,
        listarCuentas,
        registroProveedor,
        fechaFinal,
        datos,
        obtenerPaises,
        detalleLiq,
        setArchivo,
        proveedor_liq,
        total_liq
    } = props;

    let autoFocus = true;

    const [estadoModal, cambiarEstadoModal] = useState(false);
    const tipoProveedor = [
        {
            value: 'L',
            label: 'LOCAL'
        },
        {
            value: 'E',
            label: 'EXTERIOR'
        },
    ];
   
    return (
        <div>
            <div className='row mb-2'>
                <div className='col-3'>
                    <Field
                        autoFocus={autoFocus}
                        disabled={bloqueo}
                        name="fechaRegistro"
                        component={renderDayPickerB}
                        msj="Fecha Registro"
                        maxDate={fechaFinal}
                    />
                </div>
                {crear === true &&
                    <div className='col-3'>
                        <Field
                            name="cuenta_debe"
                            placeholder="Cuenta contable debe..."
                            className="form-control-find"
                            component={AsyncSelectField}
                            loadOptions={listarCuentas}
                            msj="Cuenta debe"
                        />
                    </div>
                }
                {(crear === false && editar === false) &&
                    <div className='col-3'>
                        <div className="form-floating">
                            <Field
                                name="serie"
                                placeholder="Serie"
                                className="form-control"
                                component={renderField}
                                disabled={true}
                                msj="Serie"
                            />
                        </div>
                    </div>
                }
                {editar === true &&
                    <div className='col-3'>
                        <div className="form-floating">
                            <Field
                                name="serie"
                                placeholder="Serie"
                                className="form-control"
                                component={renderField}
                                disabled={true}
                                msj="Serie"
                            />
                        </div>
                    </div>
                }
                {crear === true &&
                    <div className='col-3'>
                        <Field
                            name="cuenta_haber"
                            placeholder="Cuenta contable haber..."
                            className="form-control-find"
                            component={AsyncSelectField}
                            loadOptions={listarCuentas}
                            msj="Cuenta haber"
                        />
                    </div>
                }
                {(crear === false && editar === false) &&
                    <div className='col-3'>
                        <div className="form-floating">
                            <Field
                                name="numeroL"
                                placeholder="Numero"
                                className="form-control"
                                component={renderField}
                                disabled={true}
                                msj="Numero"
                            />
                        </div>
                    </div>
                }
            </div>
            {crear === false && editar == false &&
                <div className='row mb-2'>
                    <div className='col-9'>
                        <Field
                            name="proveedorN"
                            placeholder="Proveedor"
                            className="form-control"
                            component={renderField}
                            disabled={bloqueo}
                            msj="Proveedor"
                        />
                    </div>
                    <div className='col-3'>
                        <div className="form-floating">
                            <Field
                                name="totalLiq"
                                placeholder="Total Liquidacion"
                                className="form-control"
                                component={renderCurrencyFloat}
                                disabled={true}
                                msj="Total Liquidación"
                            />
                        </div>
                    </div>
                </div>
            }
            {(crear === true) &&
                <div className='mb-2'>
                    <div className='mb-2'>
                        {detalleLiq.length === 0 &&
                            <div className='row'>
                                <div className='col-9'>
                                    <Field
                                        name="proveedor_liquidacion"
                                        placeholder="Proveedor..."
                                        className="form-control-find"
                                        component={AsyncSelectField}
                                        loadOptions={listarProveedores}
                                        msj="Proveedor"
                                    />
                                </div>
                                <div className='col-3 mt-2'>
                                    <button
                                        className='btn mr-2 mb-3 btn-secondary'
                                        onClick={() => cambiarEstadoModal(!estadoModal)}
                                    >
                                        Crear nuevo proveedor
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                    {detalleLiq.length >= 1 &&
                        <div className='row mb-2'>
                            <div className='col-9'>
                                <div className="form-floating">
                                    <input
                                        placeholder="Proveedor"
                                        type="text"
                                        autocomplete="off"
                                        name="numeroe"
                                        className="form-control"
                                        value={proveedor_liq}
                                        disabled={true}
                                    />
                                    <label className='form-label' htmlFor="proveedor">
                                        Proveedor
                                    </label>
                                </div>
                            </div>
                            <div className='col-3'>
                                <div className="form-floating">
                                    <input
                                        placeholder="Total Liquidación"
                                        type="number"
                                        autocomplete="off"
                                        className="form-control"
                                        value={total_liq}
                                        disabled={true}
                                    />
                                    <label className='form-label' htmlFor="proveedor">
                                        Total Liquidación
                                    </label>
                                </div>
                            </div>
                        </div>
                    }
                    
                </div>
            }
            {(editar == true) &&
                <Field
                    name="proveedorN"
                    placeholder="Proveedor"
                    className="form-control"
                    component={renderField}
                    disabled={true}
                    msj="Proveedor"
                />
            }
            {(editar == true) &&
                <div className='row'>
                    <div className='col-9'>
                        <Field
                            name="proveedor_liquidacion"
                            placeholder="Proveedor..."
                            className="form-control-find"
                            component={AsyncSelectField}
                            loadOptions={listarProveedores}
                            msj="Proveedor"
                        />
                    </div>
                </div>
            }
            <div className='mb-2'>
                <Field
                    name="observaciones"
                    placeholder="Descripcion"
                    component={renderField}
                    className="form-control"
                    disabled={bloqueo}
                    msj="Observaciones"
                />
            </div>
            <h5 className="p-2 bg-secondary title mt-1">Documentos</h5>
            {(crear === true && detalleLiq.length == 0) &&
                <div className='mb-2 row d-flex justify-content-center'>
                    <div className='col-3'>
                        <Field
                            photo={''}
                            setFile={setArchivo}
                            name="archivo"
                            component={renderFilePickerB}
                        />
                    </div>
                </div>
            }
            <Modal
                estado={estadoModal}
                cambiarEstado={cambiarEstadoModal}
                titulo="Crear proveedor"
                botonCerrar="true"
            >
                <div className="d-flex flex-column flex-1 mx-4">
                    <div className='mb-2 w-25'>
                        <Field
                            autoFocus={autoFocus}
                            name="identificadorPro"
                            placeholder="Identificador"
                            className="form-control"
                            component={renderField}
                            msj="Identificador"
                        />
                    </div>
                    <div className='mb-2 w-50'>
                        <Field
                            name="nombre"
                            placeholder="Nombre"
                            className="form-control"
                            component={renderField}
                            msj="Nombre"
                        />
                    </div>
                    <div className='mb-2 w-75'>
                        <Field
                            name="direccion"
                            placeholder="Direccion"
                            className="form-control"
                            component={renderField}
                            msj="Dirección"
                        />
                    </div>
                    <div className='row'>
                        <div className='col-4'>
                            <Field
                                name="telefono"
                                placeholder="Telefono"
                                className="form-control"
                                component={renderField}
                                msj="Telefono"
                            />
                        </div>
                        <div className='col-4'>
                            <Field
                                name="correo"
                                placeholder="Correo electrónico"
                                className="form-control"
                                component={renderField}
                                msj="Correo electronico"
                            />
                        </div>
                        <div className='col-4'>
                            <Field
                                name="dias_credito"
                                placeholder="Dias credito"
                                className="form-control"
                                component={renderNumber}
                                msj="Dias crédito"
                            />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <div className='col-4'>
                            <Field
                                name="limite_credito"
                                placeholder="Limite credito"
                                className="form-control"
                                component={renderNumber}
                                msj="Limite crédito"
                            />
                        </div>
                        <div className='col-4'>
                            <div className="form-floating">
                                <Field
                                    name="tipo_proveedor"
                                    options={tipoProveedor}
                                    dato={0}
                                    component={SelectField}
                                    className="form-select"
                                    msj="Tipo proveedor"
                                />
                            </div>
                        </div>
                        <div className='col-4'>
                            {obtenerPaises &&
                                <div className="form-floating">
                                    <Field
                                        name="pais"
                                        options={obtenerPaises}
                                        crear={crear}
                                        dato={0}
                                        component={SelectField}
                                        className="form-select"
                                        msj="Pais"
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    <div className='d-flex flex-row mt-3'>

                        <button
                            className='btn mr-2 mb-3 btn-primary'
                            onClick={() => registroProveedor(datos)}
                        >
                            Guardar
                        </button>

                        <button
                            className='btn mr-2 mb-3 btn-secondary'
                            onClick={() => cambiarEstadoModal(false)}
                        >
                            Salir
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

LiquidacionBonosForm.propTypes = {
    listarProveedores: PropTypes.object,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    tipos: PropTypes.object,
    editar: PropTypes.bool,
    bloqueo: PropTypes.bool,
    listarCuentas: PropTypes.object,
    listarProveedoresD: PropTypes.object,
    registroProveedor: PropTypes.func,
    periodoD: PropTypes.object,
    fechaInicio: PropTypes.string,
    fechaFinal: PropTypes.string,
    datos: PropTypes.object,
    obtenerPaises: PropTypes.object,
    impuesto: PropTypes.object,
};

export default reduxForm({
    form: 'FormLiquidacionBonos',
})(LiquidacionBonosForm);
